import { render, staticRenderFns } from "./companies-searchbar.vue?vue&type=template&id=065f21b7&"
import script from "./companies-searchbar.vue?vue&type=script&lang=js&"
export * from "./companies-searchbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports